module.exports = __webpack_public_path__ + "img/transparent_doc.1dae02eb.svg";